import { render } from "./NpcTrader.vue?vue&type=template&id=fcd54154"
import script from "./NpcTrader.vue?vue&type=script&lang=js"
export * from "./NpcTrader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/NpcTrader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fcd54154"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fcd54154', __exports__)) {
    api.reload('fcd54154', __exports__)
  }
  
  module.hot.accept("./NpcTrader.vue?vue&type=template&id=fcd54154", () => {
    api.rerender('fcd54154', render)
  })

}


export default __exports__